<template>
  <transition name="slide-left" mode="out-in">
    <check-eligibility
      v-if="currentStep === 1"
      class="transition-all duration-150"
      :redirectTo="redirectTo"
      @advanceStep="advanceStep"
    />
    <request-upgrade
      v-if="currentStep === 2"
      class="transition-all duration-150"
      :redirectTo="redirectTo"
      :preselectedCompany="selectedCompany"
      @advanceStep="advanceStep"
    />
    <upgrade-request-sent v-if="currentStep === 3" class="transition-all duration-150" />
  </transition>
</template>

<script lang="ts">
import CheckEligibility from './components/CheckEligibility.vue';
import RequestUpgrade from './components/RequestUpgrade.vue';
import UpgradeRequestSent from './components/UpgradeRequestSent.vue';

export default {
  name: 'UpgradeFlow',
  components: {
    CheckEligibility,
    RequestUpgrade,
    UpgradeRequestSent,
  },
  data(): any {
    return {
      redirectTo: this.$route.query.redirectTo ? this.$route.query.redirectTo : '/upgrade/pricing',
      selectedCompany: {},
      currentStep: 1,
    };
  },
  methods: {
    advanceStep(selectedCompany) {
      this.selectedCompany = selectedCompany;
      if (this.currentStep < 3) {
        this.currentStep += 1;
      }
    },
  },
};
</script>
